import React from 'react';
import App from '../components/App';


const Home = () => {
    return (
        <App />
    )
}

export default Home
